// SeriesSlider.jsx
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import { useNavigate } from 'react-router-dom';
import styles from './Component/CSS/SimilarSeriesSection.module.css';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const SeriesSlider = ({ similarSeries }) => {
  const navigate = useNavigate();

  return (
    <div className={styles.sliderContainer}>
      <h2 className={styles.Heading}>Similar Series</h2>
      <Swiper
        modules={[Navigation, Pagination]}
        spaceBetween={20}
        slidesPerView={3}
        navigation
        pagination={{ clickable: true }}
        breakpoints={{
          320: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
        }}
        className={styles.swiper}
      >
        {similarSeries?.map((series) => (
          <SwiperSlide
            key={series.id}
            className={styles.slide}
            onClick={() => navigate(`/audioseries/${series.slug}`)}
          >
            <img
              src={series.coverImageUrl}
              alt={series.title}
              className={styles.seriesImage}
            />
             </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default SeriesSlider;